namespace $ {

	export type $shm_hitalama_map_access_invitation_data = {
		version: 1
		recipient: string
		map: string
		grant_time: number
		active: boolean
		title: string
		/** A protected registry administrator indexes an existing signed Gift. */
		backfill?: true
	}

	export class $shm_hitalama_map_access_invitation extends $mol_object {

		static parse( value: unknown ): $shm_hitalama_map_access_invitation_data | null {
			if( !value || typeof value !== 'object' || Array.isArray( value ) ) return null
			const data = value as Partial< $shm_hitalama_map_access_invitation_data >
			if( data.version !== 1 || typeof data.active !== 'boolean' ) return null
			if( data.backfill !== undefined && data.backfill !== true ) return null
			if( typeof data.title !== 'string' || data.title.length > 1024 ) return null
			if( !Number.isSafeInteger( data.grant_time ) || data.grant_time! <= 0 ) return null
			if( typeof data.recipient !== 'string' || !/^[a-zA-ZæÆ0-9]{8}_[a-zA-ZæÆ0-9]{8}$/.test( data.recipient ) ) return null
			if( typeof data.map !== 'string' ) return null
			const link = this.$.$giper_baza_link.check( data.map )
			if( !link?.lord().str || link.land().str !== data.map || link.lord().str.length !== 17 ) return null
			return data as $shm_hitalama_map_access_invitation_data
		}

		/** The registry is discovery only; a current personal Gift proves access. */
		static granted( land: $giper_baza_land, signer: $giper_baza_link, data: $shm_hitalama_map_access_invitation_data,
			registry?: $giper_baza_land | null ) {
			if( !this.parse( data ) ) return false
			if( !data.active || data.map !== land.link().str ) return false
			// Historical indexing does not give the service map-administration
			// rights. Its authority comes from the registry referenced by the
			// protected domain; the actual map Gift is still checked below.
			const authority = data.backfill ? registry : land
			if( !authority || authority.lord_rank( signer ) < this.$.$giper_baza_rank_rule ) return false
			const gift = land._gift.get( data.recipient )
			return !!gift && gift.rank() >= this.$.$giper_baza_rank_read && gift.time_tick() === data.grant_time
		}

	}

}
